import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiSearch, FiBell, FiUser, FiMenu } from 'react-icons/fi';
import { notificationAPI } from '../../services/api';

const Topbar = ({ onToggleSidebar }) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const { data } = await notificationAPI.list({ limit: 1 });
        setUnreadCount(data.unread_count || 0);
      } catch (e) { /* ignore */ }
    };
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <header className="topbar">
      <div className="topbar-left">
        {onToggleSidebar && (
          <button 
            type="button"
            className="topbar-menu-btn" 
            onClick={onToggleSidebar}
            aria-label="Ouvrir le menu de navigation"
            title="Menu"
          >
            <FiMenu size={22} />
          </button>
        )}
        <div className="topbar-search">
          <FiSearch />
          <input type="text" placeholder="Rechercher..." />
        </div>
      </div>

      <div className="topbar-actions">
        <button 
          type="button"
          className="topbar-btn" 
          onClick={() => navigate('/notifications')}
          title="Notifications"
        >
          <FiBell />
          {unreadCount > 0 && <span className="badge-count">{unreadCount > 99 ? '99+' : unreadCount}</span>}
        </button>
        <button 
          type="button"
          className="topbar-btn" 
          onClick={() => navigate('/profile')}
          title="Mon profil"
        >
          <FiUser />
        </button>
      </div>
    </header>
  );
};

export default Topbar;
